import React, { Suspense, useEffect, useState } from "react";
import HomeBanner from "../Components/HomeBanner/HomeBanner";
import GetApiCall from "../Helper/GetApi";
import PostApiCall from "../Helper/PostApi";

import ModalAward from "../Components/ModalPage/ModalAward";

const GetSeoData = React.lazy(() => import("../Helper/GetSeoData"));
const ComboSection = React.lazy(() => import("../Components/Combo/ComboSection"));
const InstagramGrid = React.lazy(() => import("../Components/InstaSection/InstaSection"));
const AccessoriesSection = React.lazy(() => import("../Components/AccessoriesSection/AccessoriesSection"));
const BagsSection = React.lazy(() => import("../Components/BagsSection/BagsSection"));
const AllFourProducts = React.lazy(() => import("../Components/AllFourProducts/AllFourProducts"));
const TestimonialSection = React.lazy(() => import("../Components/TestimonialSection/TestimonialSection"));
const HomeAbout = React.lazy(() => import("../Components/HomeAbout/HomeAbout"));

export default function Home() {
  const [bestSeller, setBestSeller] = useState([]);
  const [accessories, setAccessories] = useState([])
  const [bagData, setBagsData] = useState([])
  const [combosData, setCombosData] = useState([])
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    GetApiCall.getRequest("GetHomepageSetup").then((resultdes) =>
      resultdes.json().then((obj) => {
        obj.data
          .filter((value) => value.fld_section_name === "Featured Products")
          .forEach((filtereddata) => {
            PostApiCall.postRequest(
              {
                sectionname: filtereddata.fld_section_name,
                itemchoice: filtereddata.fld_item_choice,
              },
              "GetWebsiteHomePageItems"
            ).then((results) => {
              if (results.status === 200 || results.status === 201) {
                results.json().then((data) => {
                  setBestSeller(data.data);
                  setLoading(false)
                });
              }
            });
          });
      })
    );
    GetAllProducts()
  }, []);


  const GetAllProducts = () => {
    PostApiCall.postRequest(
      {
        // verticalid: 4,
        stateid: null,
      },
      "Get_All_Items"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setAccessories(obj1.data.filter((item) => item.fld_categoryname === "Accessories").filter((items) => items.fld_status === "Active").slice(0, 4));
          setBagsData(obj1.data.filter((item) => item.fld_categoryname === "Bags").filter((items) => items.fld_status === "Active").slice(0, 4));
          setCombosData(obj1.data.filter((item) => item.fld_categoryname === "Combos").filter((items) => items.fld_status === "Active").slice(0, 4));
        }
      })
    );
  };

  return (
    <>
      <ModalAward />
      <HomeBanner />
      <Suspense fallback={""}>
        <GetSeoData type="Home" id={null} />
        <AllFourProducts perfumeData={bestSeller} loadingState={loading} />
        <AccessoriesSection accessories={accessories} loadingState={false} />
        <ComboSection bagData={combosData} loadingState={false} />
        <BagsSection bagData={bagData} loadingState={false} />
        <HomeAbout />
        <InstagramGrid />
        <TestimonialSection />
      </Suspense>
    </>
  );
}
